<div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()">
</div>
<form>
    <div class="accordion-class">
        <h5>Edit Documents</h5>
        <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container">
        <div class="group">
            <mat-form-field>
                <mat-label>Document Name:</mat-label>
                <input matInput required>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Select a module:</mat-label>
                <input matInput required>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Document Status:</mat-label>
                <input matInput required>
            </mat-form-field>
        </div>
    </div>
    <i class="fa fa-spinner fa-spin"></i>
    <button type="button" class="button buttonBlue">Add Document

    </button>
</form>